import Group from 'components/utils/Group'
import Label from 'LuxKit/Label/Label'
import styled from 'styled-components'

export const AppliedPercentageLabel = styled(Label)`
  flex-shrink: 0;
  white-space: nowrap;

  > * {
    white-space: nowrap;
  }
`

export const CommissionHeadingGroup = styled(Group)`
  min-width: 0;

  > :first-child {
    min-width: 0;
  }
`
